import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d6e2b32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "select-list" }
const _hoisted_2 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CallInfo = _resolveComponent("CallInfo")!
  const _component_DropdownList = _resolveComponent("DropdownList")!

  return (_openBlock(), _createBlock(_component_DropdownList, { class: "transfer-dropdown" }, {
    default: _withCtx(() => [
      _createElementVNode("ul", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.candidatesForTransfer, (item, key) => {
          return (_openBlock(), _createElementBlock("li", {
            class: "list-item",
            key: key,
            onClick: ($event: any) => (_ctx.transferCall(item.id))
          }, [
            _createVNode(_component_CallInfo, { callData: item }, null, 8, ["callData"])
          ], 8, _hoisted_2))
        }), 128))
      ])
    ]),
    _: 1
  }))
}